import PropTypes from 'prop-types';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { jsx as _jsx } from "react/jsx-runtime";
const ListBranchActionHistoryCard = ({
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel
  });
};
ListBranchActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node
};
export default ListBranchActionHistoryCard;